import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  loadUnionCategoriesAndItems,
  loadUnionItemVariants,
} from 'actions/customers/loyalty';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import _ from 'lodash';
import Option from '../../Option';
import styles from './AddRewardModal.css';
import PercentageDiscountTotalSalesInput from './PercentageDiscountTotalSalesInput';
import AmountDiscountTotalSalesInput from './AmountDiscountTotalSalesInput';
import PercentageDiscountItemInput from './PercentageDiscountItemInput';

class AddRewardModal extends Component {
  constructor(props) {
    super(props);
    this.state = this._initialState();
  }

  componentWillMount() {
    this.props.dispatch(loadUnionCategoriesAndItems());
  }

  render() {
    const detailPro = this.props.loyaltySubscription.subscriptionDetail[
      'Loyalty Pro'
    ];
    const { rewardType, discountType } = this.state;
    return (
      <div>
        <Modal show={this.props.show} backdrop="static">
          <Modal.Header>
            <Modal.Title style={{ color: '#ffffff' }} className="text-center">
              Add Reward
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '25px 47px 15px 47px' }}>
            <div className={`${styles.title} bottom20`}>Reward Type</div>
            <div className={`row ${styles['reward-type-row']}`}>
              <div className={`${styles['reward-type']}`}>
                <div
                  className={`${styles.reward} ${styles.enabled} ${
                    rewardType === 'TOTAL_SALES' &&
                    discountType === 'PERCENTAGE'
                      ? styles.active
                      : ''
                  } cursor-pointer`}
                >
                  <Option
                    img={require('assets/images/percentage.png')}
                    title="% discount on total sale"
                    isDisabled={false}
                    rewardType="TOTAL_SALES"
                    discountType="PERCENTAGE"
                    onClick={this._onClickOption}
                  />
                </div>
              </div>
              <div className={`${styles['reward-type']}`}>
                <div
                  className={`${styles.reward} ${styles.enabled} ${
                    rewardType === 'TOTAL_SALES' && discountType === 'AMOUNT'
                      ? styles.active
                      : ''
                  } cursor-pointer`}
                >
                  <Option
                    img={require('assets/images/rp.png')}
                    title="Rp. discount on total sale"
                    isDisabled={false}
                    rewardType="TOTAL_SALES"
                    discountType="AMOUNT"
                    onClick={this._onClickOption}
                  />
                </div>
              </div>
              <div className={`${styles['reward-type']}`}>
                {detailPro.is_active && (
                  <div
                    className={`${styles.reward} ${styles.enabled} ${
                      rewardType === 'ITEM' && discountType === 'PERCENTAGE'
                        ? styles.active
                        : ''
                    } cursor-pointer`}
                  >
                    <Option
                      img={require('assets/images/ic-gift.png')}
                      title="% discount on specific item"
                      isDisabled={false}
                      rewardType="ITEM"
                      discountType="PERCENTAGE"
                      onClick={this._onClickOption}
                    />
                  </div>
                )}
                {!detailPro.is_active && (
                  <div
                    className={`${styles.reward} ${styles.disabled} cursor-not-allowed`}
                  >
                    <Option
                      img={require('assets/images/ic-gift.png')}
                      title="% discount on specific item"
                      isDisabled
                    />
                  </div>
                )}
                {!detailPro.is_active && (
                  <img
                    src={require('assets/images/pro-icon.png')}
                    className={styles['corner-icon']}
                  />
                )}
              </div>
            </div>

            {rewardType === 'TOTAL_SALES' && discountType === 'PERCENTAGE' && (
              <div>Customers get a % discount on the total sale</div>
            )}
            {rewardType === 'TOTAL_SALES' && discountType === 'AMOUNT' && (
              <div>Customers get a Rp. discount on the total sale</div>
            )}
            {rewardType === 'ITEM' && discountType === 'PERCENTAGE' && (
              <div>
                <div>Customers get a % discount on specific items</div>
                <div className={styles.description}>
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip>
                        Discount can only be applied to one item unit in a
                        single transaction
                      </Tooltip>
                    }
                  >
                    <i className={`fa fa-exclamation-circle fa-fw`} />
                  </OverlayTrigger>
                  Applies to one unit per transaction
                </div>
              </div>
            )}
            {rewardType === 'TOTAL_SALES' && discountType === 'PERCENTAGE' && (
              <PercentageDiscountTotalSalesInput
                point={this.state.point}
                onChangePoint={this._onChangePoint}
                pointInputError={this.state.pointInputError}
                discount={this.state.discount}
                onChangeDiscount={this._onChangeDiscount}
                discountInputError={this.state.discountInputError}
                isMaximumDiscountEnabled={this.state.isMaximumDiscountEnabled}
                onChangeMaximumDiscountCheckbox={
                  this._onChangeMaximumDiscountCheckbox
                }
                maximumDiscount={this.state.maximumDiscount}
                onChangeMaximumDiscount={this._onChangeMaximumDiscount}
                maximumDiscountInputError={this.state.maximumDiscountInputError}
              />
            )}
            {rewardType === 'TOTAL_SALES' && discountType === 'AMOUNT' && (
              <AmountDiscountTotalSalesInput
                point={this.state.point}
                onChangePoint={this._onChangePoint}
                pointInputError={this.state.pointInputError}
                discount={this.state.discount}
                onChangeDiscount={this._onChangeDiscount}
                discountInputError={this.state.discountInputError}
                isMinimumPurchaseEnabled={this.state.isMinimumPurchaseEnabled}
                onChangeMinimumPurchaseCheckbox={
                  this._onChangeMinimumPurchaseCheckbox
                }
                minimumPurchase={this.state.minimumPurchase}
                onChangeMinimumPurchase={this._onChangeMinimumPurchase}
                minimumPurchaseInputError={this.state.minimumPurchaseInputError}
              />
            )}
            {rewardType === 'ITEM' && discountType === 'PERCENTAGE' && (
              <PercentageDiscountItemInput
                point={this.state.point}
                onChangePoint={this._onChangePoint}
                pointInputError={this.state.pointInputError}
                discount={this.state.discount}
                onChangeDiscount={this._onChangeDiscount.bind(this)}
                discountInputError={this.state.discountInputError}
                rewardItems={this.state.rewardItems}
                rewardItemTypes={this.state.rewardItemTypes}
                selectedRewardItemType={this.state.selectedRewardItemType}
                onSelectRewardItemType={this._onSelectRewardItemType}
                onSelectCategory={this._onSelectCategory}
                onSelectItem={this._onSelectItem}
                onSelectItemVariant={this._onSelectItemVariant}
                addItem={this._addItem}
                removeItem={this._removeItem}
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              onClick={this._onClickCancel}
              className="btn btn-default pull-left"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={this._onClickAdd}
              className="btn btn-primary pull-right"
              disabled={this._isAddButtonDisabled()}
            >
              Add
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  _initialState = () => {
    const rewardItemTypes = {
      category: 'CATEGORY',
      item: 'ITEM',
      itemVariant: 'ITEM_VARIANT',
    };
    return {
      discountInputError: null,
      pointInputError: null,
      maximumDiscountInputError: null,
      minimumPurchaseInputError: null,
      rewardType: 'TOTAL_SALES',
      discountType: 'PERCENTAGE',
      point: '',
      discount: '',
      maximumDiscount: '',
      isMaximumDiscountEnabled: false,
      minimumPurchase: '',
      isMinimumPurchaseEnabled: false,
      rewardItems: [
        {
          type: rewardItemTypes.item,
          item_name: null,
          item_variant_names: null,
        },
      ],
      rewardItemTypes,
      selectedRewardItemType: rewardItemTypes.item,
    };
  };

  _isAddButtonDisabled = () => {
    const {
      discountInputError,
      pointInputError,
      maximumDiscountInputError,
      minimumPurchaseInputError,
      isMaximumDiscountEnabled,
      isMinimumPurchaseEnabled,
      rewardType,
      discountType,
      rewardItems,
    } = this.state;
    if (discountInputError !== '' || pointInputError !== '') {
      return true;
    }

    if (isMaximumDiscountEnabled && maximumDiscountInputError !== '') {
      return true;
    }

    if (isMinimumPurchaseEnabled && minimumPurchaseInputError !== '') {
      return true;
    }

    if (rewardType === 'ITEM' && discountType === 'PERCENTAGE') {
      if (_.isEmpty(rewardItems)) {
        return true;
      }
      const { rewardItemTypes, selectedRewardItemType } = this.state;
      for (let i = 0; i < rewardItems.length; i++) {
        const rewardItem = rewardItems[i];
        if (
          selectedRewardItemType === rewardItemTypes.category &&
          _.isEmpty(rewardItem.category_name)
        ) {
          return true;
        }
        if (
          selectedRewardItemType === rewardItemTypes.item &&
          (_.isEmpty(rewardItem.item_name) ||
            _.isEmpty(rewardItem.item_variant_names))
        ) {
          return true;
        }
      }
    }

    return false;
  };

  _onClickOption = (rewardType, discountType) => {
    this.setState(this._initialState());
    this.setState({ rewardType, discountType });
  };

  _onClickCancel = e => {
    e.stopPropagation();
    this.setState(this._initialState());
    this.props.hideModal();
  };

  _onChangePoint = (displayedPoint, rawPoint) => {
    let pointInputError = '';
    if (rawPoint <= 0) {
      pointInputError = 'Please input a value';
    } else {
      const { rewards } = this.props;
      const maximum = 999999999999;
      if (rawPoint > maximum) {
        rawPoint = this.state.point;
      }

      if ($.isNumeric(rawPoint)) {
        rawPoint = parseInt(rawPoint);
      }

      if (this.state.rewardType === 'TOTAL_SALES') {
        for (let i = 0; i < rewards.length; i++) {
          if (
            rewards[i].point === rawPoint &&
            rewards[i].rewardType === this.state.rewardType &&
            rewards[i].discountType === this.state.discountType
          ) {
            pointInputError =
              'Value cannot be the same with the existing rewards';
          }
        }
      }
    }

    this.setState({ point: rawPoint, pointInputError });
  };

  _onChangeDiscount = (displayedDiscount, rawDiscount) => {
    let discountInputError = '';
    if (rawDiscount <= 0) {
      discountInputError = 'Please input a value';
    } else {
      const { rewards } = this.props;
      const maximum =
        this.state.discountType === 'PERCENTAGE' ? 100 : 999999999999;
      if (rawDiscount > maximum) {
        rawDiscount = this.state.discount;
      }

      if ($.isNumeric(rawDiscount)) {
        rawDiscount = parseInt(rawDiscount);
      }

      if (this.state.rewardType === 'TOTAL_SALES') {
        for (let i = 0; i < rewards.length; i++) {
          if (
            rewards[i].discount === rawDiscount &&
            rewards[i].rewardType === this.state.rewardType &&
            rewards[i].discountType === this.state.discountType
          ) {
            discountInputError =
              'Value cannot be the same with the existing rewards';
          }
        }
      }
    }
    this.setState({ discount: rawDiscount, discountInputError });
  };

  _onChangeMaximumDiscount = (displayedDiscount, rawDiscount) => {
    let maximumDiscountInputError = '';
    if (rawDiscount < 1000) {
      maximumDiscountInputError = 'Minimum value is Rp 1000';
    } else {
      const maximum = 999999999999;
      if (rawDiscount > maximum) {
        rawDiscount = this.state.maximumDiscount;
      }

      if ($.isNumeric(rawDiscount)) {
        rawDiscount = parseInt(rawDiscount);
      }
    }

    this.setState({ maximumDiscount: rawDiscount, maximumDiscountInputError });
  };

  _onChangeMinimumPurchase = (displayedPurchase, purchase) => {
    let minimumPurchaseInputError = '';
    if (purchase < 1000) {
      minimumPurchaseInputError = 'Minimum value is Rp 1000';
    } else {
      const maximum = 999999999999;
      if (purchase > maximum) {
        purchase = this.state.minimumPurchase;
      }

      if ($.isNumeric(purchase)) {
        purchase = parseInt(purchase);
      }
    }

    this.setState({ minimumPurchase: purchase, minimumPurchaseInputError });
  };

  _onClickAdd = e => {
    e.stopPropagation();
    const {
      rewardType,
      point,
      discount,
      discountType,
      minimumPurchase,
      maximumDiscount,
      rewardItems,
    } = this.state;
    this.props.hideModal();
    this.props.addReward({
      rewardType,
      discountType,
      point,
      discount,
      minimumPurchase,
      maximumDiscount,
      rewardItems,
    });
    this.setState(this._initialState());
  };

  _onChangeMaximumDiscountCheckbox = () => {
    const nextCheckBoxState = !this.state.isMaximumDiscountEnabled;
    if (!nextCheckBoxState) {
      this.setState({
        maximumDiscount: '',
        maximumDiscountInputError: null,
      });
    }
    this.setState({ isMaximumDiscountEnabled: nextCheckBoxState });
  };

  _onChangeMinimumPurchaseCheckbox = () => {
    const nextCheckBoxState = !this.state.isMinimumPurchaseEnabled;
    if (!nextCheckBoxState) {
      this.setState({
        minimumPurchase: '',
        minimumPurchaseInputError: null,
      });
    }
    this.setState({ isMinimumPurchaseEnabled: nextCheckBoxState });
  };

  _onSelectRewardItemType = rewardItemType => {
    let rewardItemsDefault = [];
    if (rewardItemType === this.state.rewardItemTypes.item) {
      rewardItemsDefault = [
        {
          type: this.state.rewardItemTypes.item,
          item_name: null,
          item_variant_names: null,
        },
      ];
    }
    this.setState({
      rewardItems: rewardItemsDefault,
      selectedRewardItemType: rewardItemType,
    });
  };

  _onSelectCategory = selectedCategory => {
    this.setState({
      rewardItems: [
        {
          type: this.state.rewardItemTypes.category,
          category_name: selectedCategory.value,
        },
      ],
    });
  };

  _onSelectItem = (itemIndex, selectedItem) => {
    if (!selectedItem) {
      return;
    }
    const rewardItem = {
      type: this.state.rewardItemTypes.item,
      item_name: selectedItem.value,
      item_variant_names: [],
    };
    this.setState({
      rewardItems: update(this.state.rewardItems, {
        [itemIndex]: { $set: rewardItem },
      }),
    });
    this.props.dispatch(loadUnionItemVariants(selectedItem.value));
  };

  _onSelectItemVariant = (itemIndex, selectedItemVariants) => {
    if (!selectedItemVariants) {
      return;
    }
    let rewardItem;
    if (
      selectedItemVariants.length === 1 &&
      selectedItemVariants[0].value === '*'
    ) {
      rewardItem = {
        type: this.state.rewardItemTypes.item,
        item_name: this.state.rewardItems[itemIndex].item_name,
        item_variant_names: _.map(selectedItemVariants, 'value'),
      };
    } else {
      rewardItem = {
        type: this.state.rewardItemTypes.itemVariant,
        item_name: this.state.rewardItems[itemIndex].item_name,
        item_variant_names: _.map(selectedItemVariants, 'value'),
      };
    }
    this.setState({
      rewardItems: update(this.state.rewardItems, {
        [itemIndex]: { $set: rewardItem },
      }),
    });
  };

  _addItem = e => {
    e.preventDefault();
    const newItem = {
      type: this.state.rewardItemTypes.item,
      item_name: null,
      item_variant_names: [],
    };
    this.setState({ rewardItems: [...this.state.rewardItems, newItem] });
  };

  _removeItem = itemIndex => {
    this.setState({
      rewardItems: update(this.state.rewardItems, {
        $splice: [[itemIndex, 1]],
      }),
    });
  };
}

AddRewardModal.propTypes = {
  rewards: PropTypes.array.isRequired,
  addReward: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
};

export default connect()(AddRewardModal);
